"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.CliQuestionName = exports.QuestionNames = void 0;
var QuestionNames;
(function (QuestionNames) {
    QuestionNames["Scratch"] = "scratch";
    QuestionNames["SctatchYes"] = "scratch-yes";
    QuestionNames["AppName"] = "app-name";
    QuestionNames["Folder"] = "folder";
    QuestionNames["ProjectPath"] = "projectPath";
    QuestionNames["ProgrammingLanguage"] = "programming-language";
    QuestionNames["ProjectType"] = "project-type";
    QuestionNames["Capabilities"] = "capabilities";
    QuestionNames["BotTrigger"] = "bot-host-type-trigger";
    QuestionNames["Runtime"] = "runtime";
    QuestionNames["SPFxSolution"] = "spfx-solution";
    QuestionNames["SPFxInstallPackage"] = "spfx-install-latest-package";
    QuestionNames["SPFxFramework"] = "spfx-framework-type";
    QuestionNames["SPFxWebpartName"] = "spfx-webpart-name";
    QuestionNames["SPFxWebpartDesc"] = "spfx-webpart-desp";
    QuestionNames["SPFxFolder"] = "spfx-folder";
    QuestionNames["OfficeAddinFolder"] = "addin-project-folder";
    QuestionNames["OfficeAddinManifest"] = "addin-project-manifest";
    QuestionNames["OfficeAddinTemplate"] = "addin-template-select";
    QuestionNames["OfficeAddinHost"] = "addin-host";
    QuestionNames["OfficeAddinImport"] = "addin-import";
    QuestionNames["Samples"] = "samples";
    QuestionNames["ReplaceContentUrl"] = "replaceContentUrl";
    QuestionNames["ReplaceWebsiteUrl"] = "replaceWebsiteUrl";
    QuestionNames["ReplaceBotIds"] = "replaceBotIds";
    QuestionNames["SafeProjectName"] = "safeProjectName";
    QuestionNames["RepalceTabUrl"] = "tdp-tab-url";
    QuestionNames["ValidateMethod"] = "validate-method";
    QuestionNames["AppPackagePath"] = "appPackagePath";
    QuestionNames["CopilotPluginExistingApi"] = "copilot-plugin-existing-api";
    QuestionNames["ApiSpecLocation"] = "openapi-spec-location";
    QuestionNames["OpenAIPluginManifest"] = "openai-plugin-manifest";
    QuestionNames["ApiOperation"] = "api-operation";
    QuestionNames["MeArchitectureType"] = "me-architecture";
    QuestionNames["ApiSpecApiKey"] = "api-key";
    QuestionNames["Features"] = "features";
    QuestionNames["Env"] = "env";
    QuestionNames["SourceEnvName"] = "sourceEnvName";
    QuestionNames["TargetEnvName"] = "targetEnvName";
    QuestionNames["TargetResourceGroupName"] = "targetResourceGroupName";
    QuestionNames["NewResourceGroupName"] = "newResourceGroupName";
    QuestionNames["NewResourceGroupLocation"] = "newResourceGroupLocation";
    QuestionNames["NewTargetEnvName"] = "newTargetEnvName";
    QuestionNames["ExistingTabEndpoint"] = "existing-tab-endpoint";
    QuestionNames["TeamsAppManifestFilePath"] = "manifest-path";
    QuestionNames["LocalTeamsAppManifestFilePath"] = "local-manifest-path";
    QuestionNames["AadAppManifestFilePath"] = "manifest-file-path";
    QuestionNames["TeamsAppPackageFilePath"] = "app-package-file-path";
    QuestionNames["ConfirmManifest"] = "confirmManifest";
    QuestionNames["ConfirmLocalManifest"] = "confirmLocalManifest";
    QuestionNames["ConfirmAadManifest"] = "confirmAadManifest";
    QuestionNames["OutputZipPathParamName"] = "output-zip-path";
    QuestionNames["OutputManifestParamName"] = "output-manifest-path";
    QuestionNames["M365Host"] = "m365-host";
    QuestionNames["ManifestPath"] = "manifest-path";
    QuestionNames["UserEmail"] = "email";
    QuestionNames["collaborationAppType"] = "collaborationType";
})(QuestionNames = exports.QuestionNames || (exports.QuestionNames = {}));
var CliQuestionName;
(function (CliQuestionName) {
    CliQuestionName["Capability"] = "capability";
})(CliQuestionName = exports.CliQuestionName || (exports.CliQuestionName = {}));
//# sourceMappingURL=questionNames.js.map